// hd-redesign-p1 — copy-to-clipboard for every discount code chip.
//
// One file for every [data-hd-copy] on the page: the offer rail's coupon cards
// and the welcome popup both need it, and binding at the document means neither
// section has to care whether the other loaded first.
//
// The label swaps for 1800ms, the export's own timing. The swapped word is read
// off data-copied / data-copy-label so the strings stay in the locale files.
//
// Failure is silent-but-honest: navigator.clipboard is unavailable on insecure
// origins and throws when the document is not focused, so the code chip beside
// the button always carries the code as selectable text. The button is an
// enhancement over a value that is already on screen.
(function () {
  "use strict";

  var TIMERS = new WeakMap();

  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest("[data-hd-copy]") : null;
    if (!btn) return;

    var code = btn.getAttribute("data-hd-copy");
    if (!code) return;

    var done = btn.getAttribute("data-copied") || "Copied";
    var idle = btn.getAttribute("data-copy-label") || btn.textContent;

    function flash() {
      btn.textContent = done;
      var t = TIMERS.get(btn);
      if (t) window.clearTimeout(t);
      TIMERS.set(
        btn,
        window.setTimeout(function () {
          btn.textContent = idle;
        }, 1800)
      );
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(flash, function () {});
    }
  });
})();
